module.exports = __webpack_public_path__ + "static/media/gn.f1d6c153.svg";